module.exports = __webpack_public_path__ + "img/logo-of-consumer-electronics-show-svg@3x.9081bc00.png";